import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showTagline?: boolean;
  whiteDrop?: boolean;
  /** White text for both words — use on dark/colored backgrounds */
  onDark?: boolean;
  /** Use image logo (green pin + package + BuyDrop text). Set to 'text' for text-only. */
  variant?: 'image' | 'text';
}

const Logo: React.FC<LogoProps> = ({
  className = '',
  size = 'md',
  showTagline = true,
  whiteDrop = false,
  onDark = false,
  variant = 'text',
}) => {
  const sizeClasses = {
    sm: { text: 'text-lg', icon: 'text-xl', tagline: 'text-[10px]', logoHeight: 40 },
    md: { text: 'text-2xl', icon: 'text-3xl', tagline: 'text-xs', logoHeight: 52 },
    lg: { text: 'text-3xl', icon: 'text-4xl', tagline: 'text-sm', logoHeight: 72 },
  };

  const currentSize = sizeClasses[size];

  if (variant === 'image') {
    return (
      <div className={`flex flex-col items-start ${className}`}>
        <img
          src="/buydrop-logo.png"
          alt="BuyDrop"
          className="w-auto object-contain"
          style={{ maxHeight: currentSize.logoHeight }}
        />
        {showTagline && (
          <span className={`${currentSize.tagline} mt-0.5 font-medium ${onDark ? 'text-green-100/80' : 'text-gray-500'}`}>
            Buy Local. Delivered Fast.
          </span>
        )}
      </div>
    );
  }

  return (
    <div className={`flex items-center ${className}`}>
      <div className="flex flex-col">
        <div className="flex items-baseline space-x-1">
          <span
            className={`${currentSize.text} font-bold leading-tight ${
              onDark
                ? 'text-white'
                : 'bg-gradient-to-r from-green-600 to-green-500 bg-clip-text text-transparent'
            }`}
          >
            Buy
          </span>
          <span
            className={`${currentSize.text} font-bold leading-tight ${
              onDark || whiteDrop ? 'text-white' : 'text-gray-900'
            }`}
          >
            Drop
          </span>
        </div>
        {showTagline && (
          <span className={`${currentSize.tagline} -mt-0.5 font-medium ${onDark ? 'text-green-100/80' : 'text-gray-500'}`}>
            Buy Local. Delivered Fast.
          </span>
        )}
      </div>
    </div>
  );
};

export default Logo;

